import React from 'react';
import { PageWithAuthorization } from '@homeproved/shared/feature-auth';
import { PageShell } from '@homeproved/com/feature-page-shell';
import { HousingAdvicePage, prefetch } from '@homeproved/com/feature-articles';
import { useLocalizedRoutes } from '@homeproved/com/feature-localized-routes';
import {
  apiFactory,
  Article,
  ArticlesApiFactory,
  getDehydratedState,
  Sector,
  SectorsApiFactory,
} from '@homeproved/shared/data-access';

interface Props {
  articles: Array<Article>;
  teasers: Array<Sector>;
}

const Index: PageWithAuthorization<Props> = ({ articles, teasers }) => {
  const { getPath } = useLocalizedRoutes();

  return (
    <PageShell relative={true} fullWidth={true}>
      <HousingAdvicePage getPath={getPath} articles={articles} teasers={teasers} />
    </PageShell>
  );
};

export async function getServerSideProps({ locale }) {
  const articlesApi = apiFactory(locale, ArticlesApiFactory);
  const sectorsApi = apiFactory(locale, SectorsApiFactory);

  let articlesData = null;
  await articlesApi
    .apiArticleGet()
    .then((result) => {
      articlesData = result;
    })
    .catch((error) => {
      console.log(error);
    });

  let teasersData = null;
  await sectorsApi
    .apiSectorTeasersGet()
    .then((result) => {
      teasersData = result;
    })
    .catch((error) => {
      console.log(error);
    });

  return {
    props: {
      articles: articlesData?.data?.data,
      teasers: teasersData?.data?.data,
      dehydratedState: await getDehydratedState(prefetch.housingAdvice(locale)),
      meta: {
        title: 'meta.titles.housingAdvice',
        description: 'meta.descriptions.housingAdvice',
      },
    },
  };
}

export default Index;
